import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // 一进入服务项目页面时需要滚动至首页服务页面板块进行显示，所以不需要一进入页面就滚动到顶部
    if (pathname === '/service') return;
    // 使用 requestAnimationFrame 确保在浏览器下一次重绘前执行滚动
    // 这样可以避免与其他动画或布局操作冲突
    const scrollTimeout = requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto', // 使用 auto 立即滚动,不使用平滑过渡,避免与页面动画冲突
      });
    });

    return () => {
      cancelAnimationFrame(scrollTimeout);
    };
  }, [pathname, search]); // 同时监听 pathname 和 search 的变化
  return null;
};

export default ScrollToTop;
